const ORDER_DETAILS_FOOTER = {
  amountKey: {
    dataAid: "amountKey",
    text: "Amount",
  },
  amountValue: {
    dataAid: "amountValue",
  },
  unitsKey: {
    dataAid: "unitsKey",
    text: "Units",
  },
  unitsValue: {
    dataAid: "unitsValue",
  },
  frequencyKey: {
    dataAid: "frequencyKey",
    text: "Frequency",
  },
  frequencyValue: {
    dataAid: "frequencyValue",
  },
  instalmentsKey: {
    dataAid: "instalmentsKey",
    text: "Instalments",
  },
  instalmentsValue: {
    dataAid: "instalmentValue",
  },
  startDateKey: {
    dataAid: "startDateKey",
    text: "Start date",
  },
  startDateValue: {
    dataAid: "startDateValue",
  },
  endDateKey: {
    dataAid: "endDateKey",
    text: "End date",
  },
  endDateValue: {
    dataAid: "endDateValue",
  },
};

const SWITCH_CARD = {
  swtichFrom: {
    dataAid: "switchFrom",
    text: "Switching from",
  },
  switchTo: {
    text: "Switching to",
  },
  fundName: {
    dataAid: "fundName",
  },
  totalUnitsKey: {
    dataAid: "keyTotalUnits",
    text: "Total units",
  },
  totalUnitsValue: {
    dataAid: "valueTotalUnits",
  },
  switchableAmountKey: {
    dataAid: "keySwitchableAmount",
    text: "Switchable amount",
  },
  switchableAmountValue: {
    dataAid: "valueSwitchableAmount",
  },
};

const REDEMPTION_FUND = {
  dataAid: "redemptionFund",
  navigationHeader: {
    dataAid: "orderDetails",
    title: "Order Details",
    subtitle: "Set up Redemption order for below funds",
  },
};

const SWITCH_FUNDS = {
  dataAid: "switchFund",
  navigationHeader: {
    dataAid: "orderDetails",
    title: "Order Details",
    subtitle: "Set up Switch order for the below funds",
  },
};

const SWP = {
  dataAid: "swp",
  navigationHeader: {
    dataAid: "orderDetails",
    title: "Order Details",
    subtitle: "Set up Systematic Withdrawal Plan(SWP) for below funds",
  },
};

const STP = {
  dataAid: "stp",
  navigationHeader: {
    dataAid: "orderDetails",
    title: "Order Details",
    subtitle: "Set up Systematic Transfer Plan (STP) for below funds",
  },
};

const ERROR = {
  dataAid: '1',
  landingHeader: {
    dataAid: "errorScreenData"
  },
  subtitle: {
    text: "You have visited an invalid url or your request has expired. Kindly contact your relationship manager or write to us using the help section of the app."
  }
}

export default {
  note: {
    dataAid: "note",
  },
  footer: {
    title: "Generate otp",
    dataAid: "primary",
  },
  error: ERROR,
  switchCard: SWITCH_CARD,
  cardFooter: ORDER_DETAILS_FOOTER,
  redeem: REDEMPTION_FUND,
  switch: SWITCH_FUNDS,
  swp: SWP,
  stp: STP
};
